import { useMemo } from 'react';

import { FormProvider } from 'core/states';
import { IPartDetails, IPartManufacturer } from 'parts/types';

import { EditPartSetupFormFields } from './EditPartSetupFormFields';
import { getDefaultValues } from './mappers';
import { editPartSetupSchema } from './schema';

interface IProps {
  part?: IPartDetails | null;
  manufacturer?: IPartManufacturer | null;
  isOpen: boolean;
  onClose: () => void;
}

export const EditPartSetup = ({ part, manufacturer, isOpen, onClose }: IProps) => {
  const defaultValues = useMemo(() => getDefaultValues(part), [part]);

  const schema = useMemo(() => editPartSetupSchema(), []);

  return (
    <FormProvider schema={schema} defaultValues={defaultValues} resetDefaultValues>
      <EditPartSetupFormFields
        part={part}
        manufacturer={manufacturer}
        isOpen={isOpen}
        onClose={onClose}
        defaultValues={defaultValues}
      />
    </FormProvider>
  );
};
